import { render, staticRenderFns } from "./TableColumn.vue?vue&type=template&id=2cb6a3a0&"
import script from "./TableColumn.vue?vue&type=script&lang=js&"
export * from "./TableColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports